import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Plus, Search, Users, Trash2, Receipt, X
} from "lucide-react";
import "./Tables.css";
import Navbar from "../components/Navbar";

function Tables() {
  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);
  const [newTableData, setNewTableData] = useState({ id: "", seats: 4 });
  const [searchQuery, setSearchQuery] = useState("");
  const [activeOrders, setActiveOrders] = useState({});

  const [tables, setTables] = useState(() => {
    const savedTables = localStorage.getItem("hotelTablesData");
    if (savedTables) {
      return JSON.parse(savedTables);
    } else {
      return Array.from({ length: 15 }, (_, i) => ({
        id: i + 1,
        seats: 4,
        status: "Available",
      }));
    }
  });

  useEffect(() => {
    const savedOrders = JSON.parse(localStorage.getItem("activeTableOrders") || "{}");
    setActiveOrders(savedOrders);
  }, []);

  useEffect(() => {
    localStorage.setItem("hotelTablesData", JSON.stringify(tables));
  }, [tables]);

  const deleteTable = (id) => {
    if (window.confirm(`Are you sure you want to delete Table ${id}?`)) {
      setTables(tables.filter((table) => table.id !== id));
    }
  };

  const handleAddNewTable = (e) => {
    e.preventDefault();
    const tableId = parseInt(newTableData.id);
    if (!tableId || tables.some(t => t.id === tableId)) {
      alert("Invalid or Duplicate table number!");
      return;
    }

    const updatedTables = [...tables, {
      id: tableId,
      seats: parseInt(newTableData.seats),
      status: "Available"
    }].sort((a, b) => a.id - b.id);

    setTables(updatedTables);
    setShowModal(false);
    setNewTableData({ id: "", seats: 4 });
  };

  const filteredTables = tables.filter((t) => {
    if (!searchQuery) return true;
    return t.id.toString() === searchQuery;
  });

  return (
    <div className="page-layout">
      <Navbar />
      <div className="main-content-wrapper">
        <div className="tables-container">

        <header className="tables-header-ui">
          <div className="title-group">
            <h1 className="serif-title">Table Management</h1>
            <p className="subtitle">Manage your hotel tables</p>
          </div>
          <button className="add-table-btn-right" onClick={() => setShowModal(true)}>
            <Plus size={18} /> Add Table
          </button>
        </header>

        <div className="search-section-ui">
          <div className="search-input-wrapper">
            <Search size={18} className="search-icon-muted" />
            <input
              type="text"
              placeholder="Search table..."
              className="ui-rounded-search"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
        </div>

        <div className="tables-grid">
          {filteredTables.map((table) => {
            const tableItems = activeOrders[table.id] || [];
            const hasOrder = tableItems.length > 0;

            return (
              <div key={table.id} className="table-card">
                <div className="card-top-content">
                  <div className="card-header">
                    <div className="table-title-group">
                      <h3>Table {table.id}</h3>
                      <div className="seats-info">
                        <Users size={14} /> {table.seats} seats
                      </div>
                    </div>
                    <span className={hasOrder ? "status-badge-occupied" : "status-badge-available"}>
                      {hasOrder ? "Occupied" : "Available"}
                    </span>
                  </div>
                </div>

                <div className="card-bottom-fixed">
                  <div className="card-footer-actions">
                    <button
                      className="create-bill-btn-primary"
                      onClick={() => navigate(`/billing/${table.id}`)}
                    >
                      <Receipt size={16} /> {hasOrder ? "View Bill" : "Create Bill"}
                    </button>

                    <button
                      className="action-icon-btn-danger"
                      onClick={() => deleteTable(table.id)}
                    >
                      <Trash2 size={16} />
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        </div>
        {/* MODAL */}
        {showModal && (
          <div className="modal-overlay" onClick={() => setShowModal(false)}>
            <div className="modal-inner" onClick={(e) => e.stopPropagation()}>
              <div className="modal-top">
                <h2>Add New Table</h2>
                <X className="modal-close-btn" onClick={() => setShowModal(false)} />
              </div>

              <form onSubmit={handleAddNewTable}>
                <div className="modal-field">
                  <label>Table Number</label>
                  <input
                    type="number"
                    required
                    value={newTableData.id}
                    onChange={(e) =>
                      setNewTableData({ ...newTableData, id: e.target.value })
                    }
                  />
                </div>

                <div className="modal-field">
                  <label>Seating Capacity</label>
                  <input
                    type="number"
                    required
                    value={newTableData.seats}
                    onChange={(e) =>
                      setNewTableData({ ...newTableData, seats: e.target.value })
                    }
                  />
                </div>

                <button type="submit" className="modal-action-btn">
                  Add Table
                </button>
              </form>
            </div>
          </div>
        )}

      </div>
    </div>
  );
}

export default Tables;